const $ = require('jquery');
import run from '../../utilities/run';
import {setOptionsForSelect} from '../../utilities/selectorHelpers';
import _ from 'underscore';
import render from '../../utilities/render';
import {setSwitchery,instantiateSwitchery} from '../../utilities/instantiateSwitchery';
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import fileUploader from '../../components/fileuploader/index';
const fileNameRowHtml = require('./html/fileNameRow.html');

// Live form from jsp
run("#workorder-form-id", ()=>{
  const el = $("#workorder-form-id");
  workOrderForm(el);
  setupEditChecker();
});



function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#workorder-form-id");
  EditChecker.bindChangeListener("span.select2");
  EditChecker.bindCancelButton("#workorder-cancel-btn");

}


function workOrderForm(el){
  const namespace = el.data("namespace");
  const submitURL = el.data("submit-wo-url");
  const woDetailURL = el.data("wo-detail-url");
  const workOrderTypeSelect = $("#create-update-wo-type");
  const workOrderTypeList = workOrderTypeSelect.data('options');
  const productLookUpURL = el.data('product-lookup-url');
  const rmaLookUpURL = el.data('rma-lookup-url');
  const orderLookUpURL = el.data('order-lookup-url');
  const shipmentLookUpURL = el.data('shipment-lookup-url');
  const worType = el.data('work-order-type');
  const facId = el.data('fac-id');
  const existingWOId = el.data('existing-wo-id');
  const woFiles = _.toArray(el.data('work-order-files'));
  const facilitiesSelect = $("#create-update-facilities");
  const facilitiesList = facilitiesSelect.data('options');
  const relatedEntities =  el.data("related-entities");
  const submitModalTitleTxt = el.data("submit-modal-title-txt");
  const submitModalBodyTxt = el.data("submit-modal-body-txt");
  const submitModalBtnTxt = el.data("submit-modal-btn-txt");
  let relatedOrderSelectData = relatedEntities;
  
let editFileList = [];
for(let i =0; i< woFiles.length ; i++){
  editFileList.push(woFiles[i].cisId);
}


  let woFileUploader = new fileUploader({
    target: '.wo-uploader',
    multiple: true,
    maxFileSize: 5,
    afterValidSelection : function(){
      $(".select-files-btn").removeClass("disabled");
      renderSelectedFilesInRow(woFiles);
      validateFileLength();
    },
    afterInvalidSelection : function(){
      renderSelectedFilesInRow(woFiles);
    }
  });

  woFileUploader.init();

  renderSelectedFilesInRow(woFiles);
  function renderSelectedFilesInRow(items) {
    const fileListHtml = (items).map((item, index) => {
      return render(fileNameRowHtml, {
        fileName: item.cisFileName,
        cisId: item.cisId
      });
    });
  $('.file-name-render-area').append(fileListHtml.join(""));
  }
  
  $('body').find(".mfu-file-input").on('change', validateFileLength);
  $('body').find(".file-remove-btn").on('click', validateFileLength);
  //$('.file-remove-btn').on('click',validateFileLength);

  $('body').find('.file-remove-btn-edit').on('click', function(e){
    e.preventDefault();
    let cisIdRemoved = $(this).children('#wo-cis-id').val();
    console.log(cisIdRemoved);
    for(let i =0; i< editFileList.length ; i++){
      if(cisIdRemoved == editFileList[i])
      editFileList.splice(i,1);
  }
  for(let i =0; i< woFiles.length ; i++){
    if(cisIdRemoved == woFiles[i].cisId)
    woFiles.splice(i,1);
}
  $(this).closest(".file-name-row").remove();
  validateFileLength();
});


  function validateFileLength(){
  let files = woFileUploader.getFiles();
  if(files != null && files.length + editFileList.length >= 11){
    $(".select-files-btn").addClass("disabled");
    $(`#${namespace}submit-wo-id`).addClass("disabled");
    $(".maxFileError").show();
  }
  else{
    $(".select-files-btn").removeClass("disabled");
    $(`#${namespace}submit-wo-id`).removeClass("disabled")
    $(".maxFileError").hide();

  }
  }

  $.each(workOrderTypeList, function(index, value) {
    const option = $('<option /\>');
    option.attr('value', value.cdmValue).text(value.cdmValue);
    workOrderTypeSelect.append(option);
  });
  
  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
      $(element).closest(appendClosest).append(error);
      } else {
      error.insertAfter(element);
      }
    }
  });
  
  validator.settings.ignore = ":disabled,:hidden";
  
  $.each(facilitiesList, function(index, value) {
    const option = $('<option /\>');
    option.attr('value', value.facId).text(value.facName);
    facilitiesSelect.append(option);
  });
  
  if(existingWOId != "")
  {
    workOrderTypeSelect.val(worType).trigger('change.select2');
    facilitiesSelect.val(facId).trigger('change.select2');
  }
  
  const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      processResults: function (data, params) {
      params.page = params.page || 1;
      return {
        results: data,
        pagination: {
          more: (params.page * 20) < data.total_count
        }
        };
      },
      cache: true
      };  
  
  function configureDataCallback({paramKey}){
    return function(params){
      return {
        [paramKey] : params.term
      };
    };
  }
  
  const switcheryConfig = {
    size:"small",
    color: '#0D74E9'
  };

  let groupedRelatedSelectData = _(relatedOrderSelectData).groupBy(function(obj){
    return obj.creToEntityType;
  });
  
  if(_.toArray(groupedRelatedSelectData.product).length > 0)
  {
    const relatedProductCheckEl = $('#woRelatedCheckbox');
    instantiateSwitchery(relatedProductCheckEl, switcheryConfig);
    setSwitchery(relatedProductCheckEl, true);
  }
  
  if(_.toArray(groupedRelatedSelectData.order).length > 0)
  {
    const relatedProductCheckEl = $('#woRelatedOrdersCheckbox');
    instantiateSwitchery(relatedProductCheckEl, switcheryConfig);
    setSwitchery(relatedProductCheckEl, true);
  }
  
  if(_.toArray(groupedRelatedSelectData.asn).length > 0)
  {
    
    const relatedProductCheckEl = $('#woInboundShipmentsCheckbox');
    instantiateSwitchery(relatedProductCheckEl, switcheryConfig);
    setSwitchery(relatedProductCheckEl, true);
    
  }
  
  if(_.toArray(groupedRelatedSelectData.rma).length > 0)
  {
    const relatedProductCheckEl = $('#woRelatedReturnsCheckbox');
    instantiateSwitchery(relatedProductCheckEl, switcheryConfig);
    setSwitchery(relatedProductCheckEl, true);
  }
  
  const relatedProductSelectArray = _(groupedRelatedSelectData.product).pluck("creToEntityId");
  setOptionsForSelect({
    list: groupedRelatedSelectData.product,
    valueDataKey: "creToEntityId",
    textDataKey: "creToEntityId",
    selectElement: $("#wo-product-look-id"),
    initialSelectValue: relatedProductSelectArray
  });
    
  const relatedOrderSelectArray = _(groupedRelatedSelectData.order).pluck("creToEntityId");
  
  setOptionsForSelect({
    list: groupedRelatedSelectData.order,
    valueDataKey: "creToEntityId",
    textDataKey: "creToEntityId",
    selectElement: $("#wo-order-lookup-id"),
    initialSelectValue: relatedOrderSelectArray
  });
    
  const relatedRMASelectArray = _(groupedRelatedSelectData.rma).pluck("creToEntityId");
  
  setOptionsForSelect({
        list: groupedRelatedSelectData.rma,
        valueDataKey: "creToEntityId",
        textDataKey: "creToEntityId",
        selectElement: $("#wo-rma-lookup-id"),
        initialSelectValue: relatedRMASelectArray
    });
    
  const relatedASNSelectArray = _(groupedRelatedSelectData.asn).pluck("creToEntityId");
  
  setOptionsForSelect({
    list: groupedRelatedSelectData.asn,
    valueDataKey: "creToEntityId",
    textDataKey: "creToEntityId",
    selectElement: $("#wo-shipment-lookup-id"),
    initialSelectValue: relatedASNSelectArray
  });

  $("#wo-product-look-id").select2({
    ajax: {
      ...select2AjaxDefaults,
      url:productLookUpURL,
      data: configureDataCallback({paramKey: 'likeSku'})
    },
    minimumInputLength: 3
  });
  
  $("#wo-order-lookup-id").select2({
    ajax: {
        ...select2AjaxDefaults,
        url:orderLookUpURL,
        data: configureDataCallback({paramKey: 'likeOrderId'})
        },
      minimumInputLength: 3
  });
  
  $("#wo-rma-lookup-id").select2({
    ajax: {
        ...select2AjaxDefaults,
        url:rmaLookUpURL,
        data: configureDataCallback({paramKey: 'likeRmaNumber'})
        },
      minimumInputLength: 3
  });
  $("#wo-shipment-lookup-id").select2({
    ajax: {
        ...select2AjaxDefaults,
        url:shipmentLookUpURL,
        data: configureDataCallback({paramKey: 'likeShipmentId'})
        },
      minimumInputLength: 3
  });
  
  let today = new Date();
  const tomorrow = today.getDate()+1;
  today.setDate(tomorrow);
  $(`#${namespace}workOrderRequested`).datepicker({
    startDate:today ,
    todayBtn: "linked",
    keyboardNavigation: false,
    autoclose: true
  });
  
    $(`#${namespace}submit-wo-id`).on("click", function(e){
      e.preventDefault();
      if(validator.elements().valid() && !($('.q-alert-red').is(':visible')))
      {
        const submitModalFlow = new SubmitModalFlow({
          confirmModalTitle: submitModalTitleTxt,
          confirmModalBody: `<div class="q-pad-all-xl">${submitModalBodyTxt}</div>`,
          confirmModalBtnText: submitModalBtnTxt,
          onConfirmClick: function() {
            submitModalFlow.showLoadingModal();
            submitWO({url: submitURL, success: submitWOSuccess, error: submitWOError}, woFileUploader.getFiles());

            function submitWO({url, success, error}, fileList){
              let formData = new FormData($('#workorder-form-id')[0]);
              let editFileIds = "";
              for(let i =0; i< editFileList.length ; i++){
                editFileIds = editFileIds.concat(editFileList[i] + ",");
              }
              if (typeof fileList != "undefined") {
                fileList.forEach(file=>{formData.append("files[]", file)});
              }
              formData.append("editFileIds",editFileIds);
              formData.append("dummy","test"); //IE needs at least one append after create FormData object, it is crazy.
              $.ajax({
                data: formData,
                url: url,
                dataType:"JSON",
                type: 'POST',
                processData: false,  // tell jQuery not to process the data
                contentType: false,   // tell jQuery not to set contentType
                success: success,
                error: error
              });
            }
            
            function submitWOSuccess(worId){
              if(worId > 0){
                EditChecker.setPageClean();
                const woDetailUrlFullURL = `${woDetailURL}&worId=${worId}`;
                $(".create-update-wo-success-anchor").attr("href",woDetailUrlFullURL);
                submitModalFlow.showSuccessModal();
                setTimeout(function() {
                  location.href = woDetailUrlFullURL;
                }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
              }else{
                submitModalFlow.showFailureModal();
              }
            }

            function submitWOError(){
              submitModalFlow.hideAllModals();
            }
          }
        });
        submitModalFlow.init();
        submitModalFlow.showConfirmModal();
      }
    });

}




// WEBPACK FOOTER //
// ./src/pages/workorder/workOrder.js